import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'

import { WinnerTableUI } from './WinnerTableUI'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class WinnerTable extends BaseTablePage {

    constructor(props) {
        super(props);
        this.getDataUrl = "api/v1/GetWinner?offset=";
        this.getExcelUrl = "/api/v1/GetWinnerExcel";
        this.className = "ChanceReport";
        this.state.mode = "table";
        this.state.searchData = {};
        if (this.props.ceremonyId > 0) {

            this.state.searchData.ceremonyId = this.props.ceremonyId;
        }


    }


    render() {
        //  if (!this.state.isLoaded) {
        //  return <div className="box-body"> در حال بارگذاری</div>;
        // }

        var excel=<div></div>;
        if(this.props.showMask!==true)
        {
            excel=
            <div className="row">
            <div className="col-md-3">
            <input type="button" className="btn btn-primary btn-block btn-flat" value="خروجی اکسل" onClick={()=>this.onExcelButtonClick(this.state.searchData)} />
            </div>
            </div>
        }

        //console.log()
        return (
            <div className="container">

                {excel}
                <br />
                <WinnerTableUI data={this.state.data} isReady={this.state.isReady} showMask={this.props.showMask} onViewClick={this.onViewClick} />
                <Pagination pageNumber={this.state.pageNumber} isReady={this.state.isReady} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/tables/winner/WinnerTable.js